"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const ShareAmendConfirmationPopup = ({ onClose }) => (react_1.default.createElement("div", { className: 'share-confirmation-popup' },
    react_1.default.createElement(Popup_1.default, { onClose: onClose },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Your shares on this work have been amended.', onConfirm: onClose, confirmButtonText: 'Done' }, "Your shares on this work will be updated in your catalog to reflect the new share percentage within 1-3 weeks."))));
exports.default = ShareAmendConfirmationPopup;
